import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '@mui/material';
import ReactPlayer from 'react-player';
import { useStyles } from '~/views/molecules/video-player/styles';
export const VideoPlayer = ({ videoThumb, videoLink }) => {
    const classes = useStyles();
    return (_jsx(Box, { children: _jsx(ReactPlayer, { url: videoLink, light: videoThumb, playing: true, controls: true, width: '100%', height: '100%', className: classes.reactPlayer }) }));
};
